import React, {useEffect} from 'react';
import Zendesk from 'react-zendesk';
import {useSelector} from 'react-redux';
import {RootState} from '../store/store';
type Props = {};

const setting = {
  color: {
    theme: '#000',
  },
  launcher: {
    chatLabel: {
      'en-US': 'Need Help',
    },
  },
  contactForm: {
    fields: [{id: 'description', prefill: {'*': 'My pre-filled description'}}],
  },
};

export default function ZendeskComp({}: Props) {
  const userInfo = useSelector(
    (state: RootState) => state.user.discordUserInfo,
  );

  if (!userInfo?.isLogin) {
    return null;
  }
  return (
    <Zendesk
      defer
      zendeskKey={process.env.REACT_APP_ZENDESK_KEY}
      {...setting}
      onLoaded={() => console.log('is loaded')}
    />
  );
}
